var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"grid gap-6 sm:grid-cols-2 xl:grid-cols-4",attrs:{"aria-label":"Lista produktów"}},_vm._l((_vm.products),function(product,index){return _c('li',{key:product.id,staticClass:"h-full"},[_c('ProductCard',{attrs:{"product":product,"supports-hover":_vm.supportsHover,"priority-image":index < 4},on:{"open":_vm.handleOpen}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }